import { defineComponent as _defineComponent } from 'vue'
import SdsDateField from '@/components/SdsDateField.vue';
import moment from 'moment';
import { useCadastroParecerReferencialStore } from '../../store/CadastroParecerReferencialStore';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAlterarDatas',
  emits: ['fechar'],
  setup(__props, { emit }) {

const store = useCadastroParecerReferencialStore();
const { modalAlterarDatas, maxDtValidadeModalAlterarDatas } =
  storeToRefs(store);



watch(
  () => modalAlterarDatas.value.dtParecer,
  async () => {
    await store.calcularDtValidade(true);
  }
);

return { __sfc: true,store, modalAlterarDatas, maxDtValidadeModalAlterarDatas, emit, SdsDateField, moment }
}

})